module.exports = __webpack_public_path__ + "static/media/Robb Clawson Headshot.4d8b4f95.jpg";